export const getStatus = (item) => {
  if (!item.status) {
    return item.confirmed ? 'approved' : 'pending';
  }

  return item.status;
};
